import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { filter, map, take } from 'rxjs/operators';
import {
  LoadAvailableContracts,
  LoadBalanceContracts,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/contracts.actions';
import { getOpenPlatformProducts } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/products.selectors';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

@Injectable()
export class LoadContractBalanceOpenPlatformCommandService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value: string, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) =>
          products.find((product) => _safe(() => product.productCode.replace(/^0+/, '') === value, false)),
        ),
      )
      .subscribe((product) => {
        if (product && product.contracts && product.contracts.length) {
          this.store.dispatch(
            new LoadAvailableContracts({
              productCode: product.productCode.replace(/^0+/, ''),
              salesDocuments: product.contracts,
            }),
          );
        }

        if (product && product.hasOwnProperty('contract')) {
          this.store.dispatch(
            new LoadAvailableContracts({
              productCode: product.productCode.replace(/^0+/, ''),
              salesDocuments: [product['contract']],
            }),
          );
          product = { ...product, contracts: [product['contract']] };
        }

        return this.store.dispatch(new LoadBalanceContracts(product));
      });
    if (!value) {
      this.store.dispatch(
        new LoadAvailableContracts({
          productCode: null,
          salesDocuments: null,
        }),
      );
    }
    formGroup.get(SpecFieldNames.CONTRACT_SELECT).setValue(undefined);
  }
}
